import React, { FC, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Navbar as GlobalNavbar, NavbarItem } from "../../Components/Layout/Navbar";
import Header from "../../Components/Layout/Header";

const Navbar: FC = () => {
    const [items, setItems] = useState<NavbarItem[]>([]);

    useEffect(() => {
        setItems([
            {
                i18nLabel: 'Usage',
                path: ''
            },
        ]);
    }, []);

    return (
        <>
            <Header title="AI Autotagging" />
            <GlobalNavbar locationBase="/ai" items={items} />
            <Outlet />
        </>
    );
};

export default Navbar;
